import React from "react"
import Third from "./Third";
import ReactDOM from 'react-dom'
import './Adding.css';





function AddingTask(){
    var count =0
    const a = <div>
        <h1 align={"center"}>TO-DO APP</h1>



            <input align ={"center"} type={"text"} placeholder={"Addtask"} id={"note"} className={"note"}/>
            <br></br>
            <input align ={"center"} className={"Add"} type={"Button"} placeholder={"Add"} value={"Add"} onClick={function (){
                const a = document.createElement("div");
                const b = document.getElementById("test");
                if(document.getElementById("note").value !== "") {


                    b.appendChild(a)
                    count++;
                    console.log(count);


                    ReactDOM.render(<Third name={document.getElementById("note").value} key={count} id={count}/>, a);
                }
                else{
                    alert("Write Something");

                }

            }}/>


        <div id={"test"}/>




    </div>



    return a





}

export default AddingTask
